import React from "react";
import "./RegistrationHeader.scss";

const RegistrationHeader = () => {
  return (
    <div data-testid="registration" className="container header ">
      <div className="subheader ">
        <h1>
          Discover the Best Rentals <br /> in Your Area Now!
        </h1>
      </div>
    </div>
  );
};

export default RegistrationHeader;
